import { FormControl, Box, FormLabel, FormHelperText, Select } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import useStore from '../../../store';
import { useEffect, useState } from 'react';
import { getFilterOptions } from '../../../utils/ews';

const EwsSummaryCompanyTypeFormField = ({
	name = null,
	label = null,
	formNameCompanyId = null,
	placeholder = null,
	required = false,
	industrial = false,
	type = null,
}) => {
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [filterOptions, setFilterOptions] = useState([]);
	useEffect(() => setFilterOptions(getFilterOptions({ industrial, user })), [industrial, user]);

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb="4" overflow="hidden">
						<FormControl id={name}>
							{label && (
								<FormLabel>
									{t(label)}
									{required && <span style={{ color: 'red' }}>*</span>}
								</FormLabel>
							)}
							<Select
								h={12}
								value={field?.value}
								onChange={(e) => {
									form?.setFieldValue(name, e.target.value);
									form?.setFieldValue(formNameCompanyId, null);
								}}
								placeholder={placeholder}
								borderRadius={c.borderRadius}
							>
								{filterOptions?.map((item, index) => (
									<option key={`option-item-${index}`} value={item?.value}>
										{t(item?.label)}
									</option>
								))}
							</Select>
							{meta.touched && meta.error && (
								<FormHelperText id="error-message-password" color="red.400" fontSize="12px">
									{t(label)} {t('is')} {t(meta.error)}
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
};

export default EwsSummaryCompanyTypeFormField;
